webpackJsonp([16],{

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_permissions__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_permissions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__modules_permissions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_user__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getters_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_js__ = __webpack_require__(334);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);






/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */],
        user: __WEBPACK_IMPORTED_MODULE_5__modules_user__["a" /* default */],
        permission: __WEBPACK_IMPORTED_MODULE_4__modules_permissions___default.a
    },
    state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_6__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_7__actions_js__["a" /* default */]
}));

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

// module.exports = {
//     server: process.env.NODE_ENV !== 'production' ? 'kgh5.hansdata.com' : 'https://kg.1ksf.cn/',
//     port: process.env.NODE_ENV !== 'production' ? '80' : '80',
//     api: process.env.NODE_ENV !== 'production' ? 'http://kgh5.hansdata.com/afzj' : 'https://kg.1ksf.cn/afzj',
// }


module.exports = {
   server:  false ? 'kgh5.hansdata.com' : 'https://kgh5.hansdata.com/',
   // server: process.env.NODE_ENV !== 'production' ? 'h5.hansdata.com' : 'https://kgh5.hansdata.com/',
   port:  false ? '80' : '80',
   // api: process.env.NODE_ENV !== 'production' ? 'http://kgh5.hansdata.com/afzj' : 'https://kgh5.hansdata.com/afzj',
   api:  false ? 'https://kgh5.hansdata.com/afzj' : 'https://kgh5.hansdata.com/afzj',
}


/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__res_font_awesome_css_font_awesome_min_css__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__res_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__res_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__other_tool_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__menu_index__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__other_store___ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_wechat_title__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_wechat_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_wechat_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__res_css_animate_css__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__res_css_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__res_css_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lib_flexible__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lib_flexible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lib_flexible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vant_lib_index_css__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vant_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vant_lib_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vconsole__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vconsole___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vconsole__);
















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vant__["b" /* default */]);

var vConsole = new __WEBPACK_IMPORTED_MODULE_14_vconsole___default.a();

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_wechat_title___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__res_css_animate_css___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.ignoredElements = ['wx-open-launch-weapp'];

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__other_tool_js__["default"]).forEach(function (key) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype[key] = __WEBPACK_IMPORTED_MODULE_6__other_tool_js__["default"][key];
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = "production" !== 'production';
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.devtools = "production" !== 'production';

__WEBPACK_IMPORTED_MODULE_7__menu_index__["a" /* default */].afterEach(function () {
    __WEBPACK_IMPORTED_MODULE_3_nprogress___default.a.done();
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    router: __WEBPACK_IMPORTED_MODULE_7__menu_index__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_8__other_store___["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_2__App_vue___default.a);
    }
}).$mount('#app');

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(167)

var Component = __webpack_require__(153)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(338),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 167:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__other_tool_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__other_utils_auth_js__ = __webpack_require__(97);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  provide: function provide() {
    return {
      reload: this.reload,
      checkToken: this.checkToken,
      setTitle: this.setTitle
    };
  },
  data: function data() {
    return {
      com: '',
      isRouterAlive: true,
      index: 1,
      title: "",
      showTab: false,
      loading: false,
      callback: null
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.initRoute(this.$route.path);
      if (to.path === "/") {}
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    console.log('组件内离开守卫', to, from);
    next();
  },
  created: function created() {
    this.initRoute(this.$route.path);
    this.getCode();
  },

  methods: {
    getCode: function getCode() {
      console.log(this.$route.path, '--------');
      var str = this.$route.path;
      var fullPath = window.location.href;
      var code = '';
      if (str.lastIndexOf("=") > -1 || str.lastIndexOf("/") > -1) {

        if (str.lastIndexOf("=") > -1) {
          code = str.substring(str.lastIndexOf("=") + 1);
        }
        if (str.lastIndexOf("/") > -1) {
          code = str.substring(str.lastIndexOf("/") + 1);
        }
        if (code) {
          code = code.trim();
        }
        console.log(code);
        if (code.length === 16) {
          localStorage.setItem('fullCode', fullPath);
          localStorage.setItem('qr', code);
          this.$router.replace({
            path: "/a_index",
            query: {
              qr: code
            }
          });
        } else if (code.length) {
          Object(__WEBPACK_IMPORTED_MODULE_2_vant__["a" /* Toast */])("此码非此活动产品瓶码,请重新扫描");
        }
      }
    },
    initRoute: function initRoute(path) {},
    setTitle: function setTitle(title, showTab) {
      this.title = title;
      this.showTab = showTab;
    },
    checkToken: function checkToken(callback) {
      this.userLogin(callback);
    },
    selectItem: function selectItem(active) {
      this.active = active;
      switch (active) {
        case 1:
          this.$router.replace('/home?com=' + this.com);
          break;
        case 2:
          this.$router.replace('/product?com=' + this.com);
          break;
        case 3:
          this.$router.replace('/cart?com=' + this.com);
          break;
        case 4:
          this.$router.replace('/my?com=' + this.com);
          break;
      }
    },
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    userLogin: function userLogin(callback) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var code, old, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.callback = callback;

                if (!_this.loading) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                _this.loading = true;
                code = __WEBPACK_IMPORTED_MODULE_3__other_tool_js__["default"].getUrlKey("code", window.location.href);
                old = localStorage.getItem("code");

                if (!(code && code != old)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_4__other_utils_auth_js__["b" /* login */])();

              case 9:
                res = _context.sent;

                console.log(res);

              case 11:
                _this.loading = false;
                typeof _this.callback == 'function' && _this.callback();

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSysStatus: function getSysStatus() {
      var _this2 = this;

      this.$http.get("/ActCtrl/getActOffLine").do(function (res) {
        if (res.cont == 20001) {
          _this2.$router.replace('/');
          window.location.href = "/static/upgrade.html";
        }
      });
    }
  }
});

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $http; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_config_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store___ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tool_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cookie_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__serverException_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__serverException_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__serverException_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tool__ = __webpack_require__(41);










var java = __WEBPACK_IMPORTED_MODULE_1__config_config_js___default.a.api;
var sn;

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = true;
var service = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    baseURL: '',
    timeout: 60000 * 2 });
service.interceptors.request.use(function (config) {

    config.headers[__WEBPACK_IMPORTED_MODULE_9__tool__["setAuthKey"]()] = localStorage.getItem("token");
    config.headers['openid'] = localStorage.getItem("openid");
    if (__WEBPACK_IMPORTED_MODULE_9__tool__ && typeof __WEBPACK_IMPORTED_MODULE_9__tool__["sn"] === "function") {
        sn = __WEBPACK_IMPORTED_MODULE_9__tool__["sn"]();
        for (var key in sn) {
            config.headers[key] = sn[key];
        }
    }
    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

service.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error && error.response.status != 404) {
        Object(__WEBPACK_IMPORTED_MODULE_7__serverException_js__["serverException"])(error.response);
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});
var CancelToken = service.CancelToken = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.CancelToken;

var $http = {
    token: function token(x) {
        return x = localStorage.getItem("token");
    },
    cancel: null,
    request: function request(path, req) {
        var _this = this;

        var that = this;
        req.loginId = localStorage.getItem("loginId");
        if (req == null || req == undefined) req = {};
        var flag = '?';
        if (path.indexOf("?") != -1) {
            flag = '&';
        }
        if (path.indexOf('codeCheckInfo') > -1) {
            java = "https://lb-system-2025.lbreeb.com/afzj";
        }
        var ax = service({
            method: 'post',
            url: '' + java + path,
            data: req,
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem("token"),
                'token': localStorage.getItem("token")
            },
            cancelToken: new CancelToken(function executor(c) {
                that.cancel = c;
            })
        });
        ax.do = function (fn) {
            _this.callback(ax, fn);
        };
        return ax;
    },
    get: function get(path, req) {
        var _this2 = this;

        var that = this;
        if (req == null || req == undefined) req = {};
        var url = this.joint(path, req);
        var ax = service({
            method: "get",
            url: url,
            crossDomain: true,
            headers: {
                "Content-Type": "application/json",
                "authorization": localStorage.getItem("token"),
                "token": localStorage.getItem("token")
            },
            cancelToken: new CancelToken(function executor(c) {
                that.cancel = c;
            })
        });
        ax.do = function (fn) {
            _this2.callback(ax, fn);
        };
        return ax;
    },
    callback: function callback(ax, fn) {
        ax.then(function (response) {
            var data = response.data;
            console.log("BEN:" + data.code);
            if (data.code == 403) {
                localStorage.removeItem("code");

                return;
            }

            fn(data);
        }).catch(function (err) {
            console.log(err);
            fn(null, err);
            Object(__WEBPACK_IMPORTED_MODULE_3_vant__["a" /* Toast */])({
                type: "fail",
                icon: "none",
                message: "服务异常"
            });
        });
    },
    download: function download(path, param) {
        window.open(this.joint(path, param));
    },
    joint: function joint(path, param) {
        if (param == null || param == undefined) param = {};
        var flag = '?';
        if (path.indexOf("?") != -1) {
            flag = '&';
        }
        var p = '' + java + path;
        for (var i in param) {
            p += '' + flag + i + '=' + param[i];
            flag = '&';
        }
        return p;
    }
};

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    pagination: {
        small: false,
        size: 20,
        pageSizes: [20, 50, 100, 200]
    },
    dialogBtnSize: 'small',
    formSize: 'small',
    formBtnSize: 'small',
    tableBtnSize: 'small',
    switchForm: {
        onColor: "#1CAF9A",
        offColor: "#bfcbd9"
    },
    breadcrumbs: '/',
    labelWidth: 80,
    elRowGutter: 10,
    tabMenu: []
});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);





var app = {
    state: {
        sidebar: {
            opened: !+__WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('sidebarStatus')
        },
        visitedViews: [],
        fold: false,
        taskStatus: '' },
    mutations: {
        ADD_VISITED_VIEWS: function ADD_VISITED_VIEWS(state, view) {
            if (state.visitedViews.some(function (v) {
                return v.path === view.path;
            })) return;
            state.visitedViews.push({ name: view.path == '/admin' ? '首页' : view.name, path: view.path });
        },
        DEL_VISITED_VIEWS: function DEL_VISITED_VIEWS(state, view) {
            var index = void 0;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.visitedViews.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref = _step.value;

                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                    var i = _ref2[0];
                    var v = _ref2[1];

                    if (v.path === view.path) {
                        index = i;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            state.visitedViews.splice(index, 1);
        },
        FOLD: function FOLD(state) {
            state.fold = !state.fold;
        },
        TASK: function TASK(state, status) {
            state.taskStatus = status;
        },
        CLEAR_VISITED_VIEWS: function CLEAR_VISITED_VIEWS(state) {
            state.visitedViews = [];
        },
        TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
            if (state.sidebar.opened) {
                __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('sidebarStatus', 1);
            } else {
                __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('sidebarStatus', 0);
            }
            state.sidebar.opened = !state.sidebar.opened;
        }
    },
    actions: {
        addVisitedViews: function addVisitedViews(_ref3, view) {
            var commit = _ref3.commit;

            commit('ADD_VISITED_VIEWS', view);
        },
        delVisitedViews: function delVisitedViews(_ref4, view) {
            var commit = _ref4.commit;

            commit('DEL_VISITED_VIEWS', view);
        },
        taskMission: function taskMission(_ref5, status) {
            var commit = _ref5.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                commit('TASK', status);
                resolve();
            });
        },
        toggleSidebar: function toggleSidebar(_ref6) {
            var commit = _ref6.commit;

            commit('TOGGLE_SIDEBAR');
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),

/***/ 331:
/***/ (function(module, exports) {



/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__other_utils_cookie_js__ = __webpack_require__(92);



var user = {
    state: {
        user: '',
        token: Object(__WEBPACK_IMPORTED_MODULE_1__other_utils_cookie_js__["a" /* getCookie */])("token"),
        roles: [],
        ticket: {},
        hasLogin: false,
        longitude: '',
        latitude: '',
        userInfo: null,
        is_sign_us: 0,
        shopInfo: null,
        dealer1Info: null,
        dealer2Info: null,
        itemInfo: null,
        codeInfo: null,
        obj1: null,
        obj2: null
    },
    mutations: {
        SET_TOKEN: function SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_USER: function SET_USER(state, name) {
            state.user = name;
        },
        SET_ROLES: function SET_ROLES(state, roles) {
            state.roles = roles;
        },
        SET_TICKET: function SET_TICKET(state, ticket) {
            state.ticket = ticket;
        },
        SET_HAS_LOGIN: function SET_HAS_LOGIN(state, login) {
            state.hasLogin = login;
        },
        SET_LONGITUDE: function SET_LONGITUDE(state, longitude) {
            state.longitude = longitude;
        },
        SET_LATITUDE: function SET_LATITUDE(state, latitude) {
            state.latitude = latitude;
        },
        SET_USERINFO: function SET_USERINFO(state, userInfo) {
            state.userInfo = userInfo;
        },
        SET_SIGN: function SET_SIGN(state, sign) {
            state.is_sign_us = sign;
        }
    },
    actions: {
        Login: function Login(_ref, login) {
            var commit = _ref.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                commit('SET_HAS_LOGIN', login);
                resolve();
            });
        },
        LoginIn: function LoginIn(_ref2, roles) {
            var commit = _ref2.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                commit('SET_ROLES', roles);
                resolve();
            });
        },
        setTicket: function setTicket(_ref3, ticket) {
            var commit = _ref3.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                commit('SET_TICKET', ticket);
                resolve();
            });
        },
        setToken: function setToken(_ref4, token) {
            var commit = _ref4.commit;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                commit('SET_TOKEN', token);
                resolve();
            });
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters = {
    visitedViews: function visitedViews(state) {
        return state.app.visitedViews;
    },
    taskStatus: function taskStatus(state) {
        return state.app.taskStatus;
    },
    sidebar: function sidebar(state) {
        return state.app.sidebar;
    },
    token: function token(state) {
        return state.user.token;
    },
    name: function name(state) {
        return state.user.name;
    },
    roles: function roles(state) {
        return state.user.roles;
    },
    setting: function setting(state) {
        return state.user.setting;
    },
    ticket: function ticket(state) {
        return state.user.ticket;
    },
    permission_routers: function permission_routers(state) {
        return state.permission.routers;
    },
    addRouters: function addRouters(state) {
        return state.permission.addRouters;
    },
    routerLoadDone: function routerLoadDone(state) {
        return state.permission.routerLoadDone;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__other_utils_cookie_js__ = __webpack_require__(92);





var actions = {
    clearRouters: function clearRouters(_ref) {
        var _this = this;

        var commit = _ref.commit,
            state = _ref.state;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                                commit('CLEAR_ROUTERS', {
                                    whole: state.permission.routers,
                                    added: state.permission.addRouters
                                });
                                resolve();
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    clearVisitedViews: function clearVisitedViews(_ref2) {
        var _this2 = this;

        var dispatch = _ref2.dispatch,
            commit = _ref2.commit;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return dispatch('clearRouters');

                        case 2:
                            commit('CLEAR_VISITED_VIEWS');

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    logOut: function logOut(_ref3) {
        var _this3 = this;

        var dispatch = _ref3.dispatch,
            commit = _ref3.commit,
            state = _ref3.state;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return dispatch('clearRouters');

                        case 2:
                            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                                commit('SET_TOKEN', '');
                                commit('SET_ROLES', []);
                                Object(__WEBPACK_IMPORTED_MODULE_3__other_utils_cookie_js__["b" /* removeCookie */])("token");
                                resolve();
                            }));

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }))();
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),

/***/ 335:
/***/ (function(module, exports) {



/***/ }),

/***/ 338:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('meta', {
    attrs: {
      "name": "referrer",
      "content": "never"
    }
  }), _vm._v(" "), (_vm.isRouterAlive) ? _c('router-view', {
    directives: [{
      name: "wechat-title",
      rawName: "v-wechat-title",
      value: (_vm.title),
      expression: "title"
    }]
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export constantRouterMap */
/* unused harmony export asyncRouterMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(343);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var constantRouterMap = [{
    path: '/a_index',
    component: function component(resolve) {
        __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(352)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '力波啤酒',
        showTab: true
    }
}, {
    path: '/a_result',
    component: function component(resolve) {
        __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(353)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '开奖结果',
        showTab: true
    }
}, {
    path: '/a_mine',
    component: function component(resolve) {
        __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(354)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '个人中心',
        showTab: true
    }
}, {
    path: '/a_records',
    component: function component(resolve) {
        __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(355)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '注册记录',
        showTab: true
    }
}, {
    path: '/a_my_prize',
    component: function component(resolve) {
        __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(356)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '我的奖品',
        showTab: true
    }
}, {
    path: '/a_register',
    component: function component(resolve) {
        __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(357)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '店主注册',
        showTab: true
    }
}, {
    path: '/b_register',
    component: function component(resolve) {
        __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(358)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '稽查员注册',
        showTab: true
    }
}, {
    path: '/b_index',
    component: function component(resolve) {
        __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(359)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '稽查员注册',
        showTab: true
    }
}, {
    path: '/b_result1',
    component: function component(resolve) {
        __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(360)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '查询结果',
        showTab: true
    }
}, {
    path: '/b_result2',
    component: function component(resolve) {
        __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(361)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '查询结果',
        showTab: true
    }
}, {
    path: '/b_query_list',
    component: function component(resolve) {
        __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(362)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '稽查记录',
        showTab: true
    }
}, {
    path: '/c_query',
    component: function component(resolve) {
        __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(363)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '上海力波啤酒箱码查验',
        showTab: true
    }
}, {
    path: '/c_result',
    component: function component(resolve) {
        __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(364)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '上海力波啤酒箱码查验结果',
        showTab: true
    }
}, {
    path: '/d_query',
    component: function component(resolve) {
        __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(365)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '上海力波啤酒内外箱码查验',
        showTab: true
    }
}, {
    path: '/d_result',
    component: function component(resolve) {
        __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(366)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
        title: '上海力波啤酒箱码查验结果',
        showTab: true
    }
}];
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    linkActiveClass: 'active',
    routes: constantRouterMap,
    base: '/',
    mode: 'history'
}));

var asyncRouterMap = [];

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["btfa"] = btfa;
/* harmony export (immutable) */ __webpack_exports__["setAuthKey"] = setAuthKey;
/* harmony export (immutable) */ __webpack_exports__["getUUID"] = getUUID;
/* harmony export (immutable) */ __webpack_exports__["sn"] = sn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_fetch_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_md5__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_md5__);






var map = [[20, 19], [14, 15, 14, 3, 5], [19, 9, 7, 14]];
var auth_map = [1, 21, 20, 8, 15, 18, 9, 26, 1, 20, 9, 15, 14];
function btfa(num) {
    return String.fromCharCode(64 + num).toLowerCase();
}
function setAuthKey() {
    var auth_key = "";
    auth_map.forEach(function (item) {
        auth_key += btfa(item);
    });
    return auth_key;
}


function isEndWith(path, endStr) {
    var diff = path.length - endStr.length;
    if (diff >= 0 && path.lastIndexOf(endStr) == diff) {
        return true;
    } else {
        return false;
    }
}

function logoutRedirect() {}

function formatDate(date, fmt) {
    if (!date) return '';
    date = date == undefined ? new Date() : new Date(date);
    date = typeof date == 'number' ? new Date(date) : date;
    fmt = fmt || 'yyyy-MM-dd HH:mm:ss';
    var obj = {
        'y': date.getFullYear(),
        'M': date.getMonth() + 1,
        'd': date.getDate(),
        'q': Math.floor((date.getMonth() + 3) / 3),
        'w': date.getDay(),
        'H': date.getHours(),
        'h': date.getHours() % 12 == 0 ? 12 : date.getHours() % 12,
        'm': date.getMinutes(),
        's': date.getSeconds(),
        'S': date.getMilliseconds() };
    var week = ['天', '一', '二', '三', '四', '五', '六'];
    for (var i in obj) {
        fmt = fmt.replace(new RegExp(i + '+', 'g'), function (m) {
            var val = obj[i] + '';
            if (i == 'w') return (m.length > 2 ? '星期' : '周') + week[val];
            for (var j = 0, len = val.length; j < m.length - len; j++) {
                val = '0' + val;
            }return m.length == 1 ? val : val.substring(val.length - m.length);
        });
    }
    return fmt;
}

function Chinese(input) {
    var numberValue = new String(Math.round(input * 100));
    var chineseValue = "";
    var String1 = "零一二三四五六七八九";
    var String2 = "万千百十亿千百十万千百十个个个";
    var len = numberValue.length;
    var Ch1;
    var Ch2;
    var nZero = 0;
    var String3;
    if (len > 15) {
        alert("超出计算范围");
        return "";
    }
    if (numberValue[0] == 'N') {
        chineseValue = "请输入二维码个数";
        return chineseValue;
    }
    if (numberValue == 0) {
        chineseValue = "零个";
        return chineseValue;
    }
    String2 = String2.substr(String2.length - len, len);
    for (var i = 0; i < len; i++) {
        String3 = parseInt(numberValue.substr(i, 1), 10);
        if (i != len - 3 && i != len - 7 && i != len - 11 && i != len - 15) {
            if (String3 == 0) {
                Ch1 = "";
                Ch2 = "";
                nZero = nZero + 1;
            } else if (String3 != 0 && nZero != 0) {
                Ch1 = "零" + String1.substr(String3, 1);
                Ch2 = String2.substr(i, 1);
                nZero = 0;
            } else {
                Ch1 = String1.substr(String3, 1);
                Ch2 = String2.substr(i, 1);
                nZero = 0;
            }
        } else {
            if (String3 != 0 && nZero != 0) {
                Ch1 = "零" + String1.substr(String3, 1);
                Ch2 = String2.substr(i, 1);
                nZero = 0;
            } else if (String3 != 0 && nZero == 0) {
                Ch1 = String1.substr(String3, 1);
                Ch2 = String2.substr(i, 1);
                nZero = 0;
            } else if (String3 == 0 && nZero >= 3) {
                Ch1 = "";
                Ch2 = "";
                nZero = nZero + 1;
            } else {
                Ch1 = "";
                Ch2 = String2.substr(i, 1);
                nZero = nZero + 1;
            }
            if (i == len - 11 || i == len - 3) {
                Ch2 = String2.substr(i, 1);
            }
        }
        chineseValue = chineseValue + Ch1 + Ch2;
    }
    return chineseValue;
}

function accurateDecimal(number, _format, _zeroFill) {
    var format = _format ? _format : 2;
    var zeroFill = _zeroFill === false ? false : true;

    if (!isEmpty(number)) {
        if (!/^\d+(\.\d+)?$|^-\d+(\.\d+)?$/.test(number)) return number;
        var n = 1;
        for (var i = 0; i < format; i++) {
            n = n * 10;
        }

        number = Math.round(number * n) / n;
        var str = number.toString();

        if (zeroFill) {
            var index = void 0;
            if (str.indexOf(".") == -1) {
                index = format;
                str += '.';
            } else {
                index = format - (str.length - 1 - str.indexOf("."));
            }
            for (var _i = 0; _i < index; _i++) {
                str += '0';
            }
        }
        return str;
    }
    return number;
};

function isEmpty(ObjVal) {
    if (ObjVal == null || typeof ObjVal == "undefined" || typeof ObjVal == "string" && ObjVal == "" && ObjVal != "undefined") {
        return true;
    } else {
        return false;
    }
}

function clone(source) {
    if (!source && (typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source)) !== 'object') {
        throw new Error('error arguments', 'shallowClone');
    }
    var targetObj = source.constructor === Array ? [] : {};
    for (var keys in source) {
        if (source.hasOwnProperty(keys)) {
            if (source[keys] && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source[keys]) === 'object') {
                targetObj[keys] = source[keys].constructor === Array ? [] : {};
                targetObj[keys] = clone(source[keys]);
            } else {
                targetObj[keys] = source[keys];
            }
        }
    }
    return targetObj;
}

function getNowFormatDate() {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
}

function getBeforeDate(n, currentdate) {
    var n = n;
    var d = new Date(currentdate);
    var year = d.getFullYear();
    var mon = d.getMonth() + 1;
    var day = d.getDate();
    if (day <= n) {
        if (mon > 1) {
            mon = mon - 1;
        } else {
            year = year - 1;
            mon = 12;
        }
    }
    d.setDate(d.getDate() - n);
    year = d.getFullYear();
    mon = d.getMonth() + 1;
    day = d.getDate();
    var beforeDate = year + "-" + (mon < 10 ? '0' + mon : mon) + "-" + (day < 10 ? '0' + day : day);
    return beforeDate;
}

var currentDate = getNowFormatDate();
var currentDate_day = getNowFormatDate();
var beforeDate = getBeforeDate(6, currentDate);
currentDate_day = new Date(currentDate_day += ' 00:00:00');
currentDate = new Date(currentDate += ' 23:59:59');

beforeDate = new Date(beforeDate += ' 00:00:00');
var bfrDate = getBeforeDate(2, currentDate);
bfrDate = new Date(bfrDate += ' 00:00:00');

function getUrlKey(name, url) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

function getCookie(key) {
    var value = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get(key);
    if (value == undefined) {
        return "";
    }
    return value;
}

function setCookie(key, value) {
    return __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set(key, value);
}

function removeCookie(key) {
    return __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.remove(key);
}

function is_wx() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}

function getUUID(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [];
    var i;
    radix = radix || chars.length;
    if (len) {
        for (i = 0; i < len; i++) {
            uuid[i] = chars[0 | Math.random() * radix];
        }
    } else {
        var r;
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[i === 19 ? r & 0x3 | 0x8 : r];
            }
        }
    }
    return uuid.join('');
}

function sn() {
    var t = Math.floor(new Date().getTime() / 1000);
    var n = getUUID(32, 16);
    var date = '' + new Date().getFullYear() + (new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1) + (new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate());
    var s = __WEBPACK_IMPORTED_MODULE_3_js_md5___default()('' + t + n + date + '12#$' + date).toUpperCase();
    var res = {};
    map.forEach(function (item, index) {
        var key = '';
        item.forEach(function (ele) {
            key += btfa(ele);
        });
        if (index == 0) {
            res[key] = t;
        } else if (index == 1) {
            res[key] = n;
        } else {
            res[key] = s;
        }
    });
    return res;
}

/* harmony default export */ __webpack_exports__["default"] = ({
    $http: __WEBPACK_IMPORTED_MODULE_1__utils_fetch_js__["a" /* $http */],
    getCookie: getCookie, setCookie: setCookie, removeCookie: removeCookie,
    logoutRedirect: logoutRedirect,
    formatDate: formatDate,
    accurateDecimal: accurateDecimal,
    clone: clone,
    Chinese: Chinese,
    currentDate: currentDate,
    currentDate_day: currentDate_day,
    beforeDate: beforeDate,
    bfrDate: bfrDate,
    isEndWith: isEndWith,
    isEmpty: isEmpty,
    getUrlKey: getUrlKey,
    is_wx: is_wx,
    sn: sn
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
/* unused harmony export setCookie */
/* harmony export (immutable) */ __webpack_exports__["b"] = removeCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


function getCookie(key) {
    var value = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(key);
    if (value == undefined) {
        return "";
    }
    return value;
}

function setCookie(key, value) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(key, value);
}

function removeCookie(key) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(key);
}

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = auth;
/* harmony export (immutable) */ __webpack_exports__["b"] = login;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tool_js__ = __webpack_require__(41);


function auth() {
  var appID = "";
  var url = window.location.href;
  if (url.indexOf("hansdata.com") > -1) {
    appID = "wx6eb720a2c4113a51";
  } else {
    appID = "wx751474581710f675";
  }
  var state = "h5";
  var strUrl = "";
  var openid = localStorage.getItem("openid");
  if (__WEBPACK_IMPORTED_MODULE_1__tool_js__["default"].isEmpty(openid)) {
    strUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appID + "&redirect_uri=" + encodeURIComponent(window.location.href.replace(/code=(\S)*&state=h5(&?)/, '')) + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect";
  } else {
    strUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appID + "&redirect_uri=" + encodeURIComponent(window.location.href.replace(/code=(\S)*&state=h5(&?)/, '')) + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect";
  }
  window.location.href = strUrl;
};

function login(type) {
  var apiStr = type === 'a' ? "/WehPubCtrl/login" : "/WehPubCtrl/checkerLogin";
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, rej) {
    var code = __WEBPACK_IMPORTED_MODULE_1__tool_js__["default"].getUrlKey("code", window.location.href);
    __WEBPACK_IMPORTED_MODULE_1__tool_js__["default"].$http.request(apiStr, { code: code }).do(function (resp) {
      if (resp.code === 100) {
        localStorage.setItem('code', code);
        localStorage.setItem('token', resp.cont.list.token);
        localStorage.setItem('openid', resp.cont.list.openid_us);
        localStorage.setItem('nickname', resp.cont.list.nickname_us);
        localStorage.setItem('headimg', resp.cont.list.headimg_us);
        localStorage.setItem('loginId', resp.cont.list.loginId);
        localStorage.setItem('lastUsetType', type);
        resolve(resp.cont);
      } else {
        rej();
      }
    });
  });
};

/***/ })

},[158]);


// WEBPACK FOOTER //
// static/js/App.ac9a18119a7eda520e66.js